import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import weddingImage from '../assets/wedding.jpg';
import decoration from '../assets/decoration.jpeg';
import venue from '../assets/venue.jpg';
import customevents from '../assets/custom-event.jpeg';
import entertainment from '../assets/Entertainment.jpg';
import "../styles/FullWidthServices.css"

const defaultServices = [
  { title: 'Wedding Planning', image: weddingImage, path: '/wedding' },
  { title: 'Design & Decoration', image: decoration, path: '/design' },
  { title: 'Destination Wedding Venues', image: venue, path: '/destination' },
  { title: 'Entertainment', image: entertainment, path: '/entertainment' },
  { title: 'Custom Events', image: customevents, path: '/others' },
];

function FullWidthServices() {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [content, setContent] = useState(null);

  // Load CMS content
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/content/services.json", { cache: "no-store" });
        if (res.ok) {
          const data = await res.json();
          setContent(data);
        }
      } catch (e) {
        console.warn("Using default services content");
      }
    })();
  }, []);

  const services = (content?.services && content.services.length > 0) ? content.services : defaultServices;
  const heading = content?.heading || "We don't just plan events — we craft unforgettable experiences that speak your story.";

  // Animation on scroll (fade + slide)
  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll('.service-card');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section" ref={sectionRef}>
      <h2 className="services-heading">
        <em>
          “We don’t just plan events — we craft unforgettable experiences that speak your story.”
        </em>
      </h2>

      <div className="services-grid">
        {services.map((service, idx) => (
          <div key={idx} className="service-card">
            <img src={service.image} alt={service.title} className="service-img" />
            <div className="overlay">
              <h3>{service.title}</h3>
              <button
                className="glass-btn"
                onClick={() => navigate(service.path)}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FullWidthServices;
